import ReactGA from 'react-ga4';


export const initializeAnalytics = () => {
  ReactGA.initialize('G-3TLW5S7E8S'); 
};

export const trackPageView = (page) => {
  ReactGA.send({ hitType: "pageview", page });
};

export const trackEvent = (category, action, label) => {
  ReactGA.event({
    category,
    action,
    label,
  });
};
